import * as React from "react";
const VisibilityIcon = (props) => (
  <svg
    aria-hidden="true"
    data-testid="VisibilityOutlinedIcon"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    {...props}
  >
    <path
      d="M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
      fill="#3C3B3D"
    />
  </svg>
);
export default VisibilityIcon;
